import { http } from 'connex-cds';

export default {
  getOrderRecipients: ({ entityRef, orderRef }) =>
    http.get({ apiName: 'mt', path: `/${entityRef}/orderRecipients/${orderRef}` }),
  updateOrderRecipients: ({ entityRef, orderRef, item }) =>
    http.put({ apiName: 'mt', path: `/${entityRef}/orderRecipients/${orderRef}`, data: item }),
};
